import { render, staticRenderFns } from "./ValidationAlarm.vue?vue&type=template&id=3036ffca&scoped=true&"
import script from "./ValidationAlarm.vue?vue&type=script&lang=js&"
export * from "./ValidationAlarm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3036ffca",
  null
  
)

export default component.exports